import {EnumToMapping, getEnumNameValueMap, Paths} from "common";
import {SortOrder} from "../domain";


export interface SubmittedRequestColumn {
    name: string;
    attr: Paths<SubmittedRequestInfo>;
}

export interface SubmittedRequestSortBy {
    column: Paths<SubmittedRequestInfo>
    order: SortOrder
}

export type SubmittedRequestInfo = {
    guid: string;
    authorizationGuid: string;
    clientGuid: string;
    caseNumber: string;
    clientName: string;
    requestType: string;
    submittedDate: string;
    submitterName: string;
    status: string;
    closedDate: string;

    origin: string;
    parentCaseGuid: string;
    reason: string;
    recordType: string;
    sfAuthId: string;
    sfId: string;
    sfClientId: string;
    sfParentCaseId: string;
    providerGuid: string;
    subject: string;
}

export enum SubmittedRequestType {
    Auth_Review_Needed = 'Auth Review Needed',
    Clinical_Consult = 'Clinical Consult',
    Client_Family_Concern = 'Client/Family Concern',
    Client_Return_Transfer_Request = 'Client Return/Transfer Request',
    Discharge_Notification = 'Discharge Notification',
    Treatment_Hold = 'Treatment Hold',
    Fso_Support = 'FSO Inquiry',
    Insurance_Notification = 'Insurance Notification',
    Missing_Documentation = 'Missing Documentation',
    No_Contact = 'No Contact',
    Provider_Data_Inquiry = 'Provider Data Inquiry',
    Report_Status_Inquiry = 'Report Status Inquiry',
    Care_Coordination = 'Care Coordination',
}

export enum SubmittedStatus {
    Active = 'Active',
    Closed = 'Closed',
    Completed = 'Completed',
    'Decision Made' = 'Decision Made',
    Inactive = 'Inactive',
    'Information Needed' = 'Information Needed',
    'In Progress' = 'In Progress',
    New = 'New',
    Pending = 'Pending',
    'Pending Approval' = 'Pending Approval',
    Resolved = 'Resolved',
}

export const {
    nameToValue: SubmittedRequestTypeMap,
    nameToValueWithDefault: SubmittedRequestTypeMapWithDefault
} = EnumToMapping(SubmittedRequestType, {value: '', label: "All Request Type"}, true);

export const {
    nameToValue: SubmittedStatusMap,
    nameToValueWithDefault: SubmittedStatusMapWithDefault
} = EnumToMapping(SubmittedStatus, {value: '', label: "All Status"}, true);

